import i18n from 'i18next';

export const changeLanguage = (language) => (dispatch) => {
    i18n.changeLanguage(language).then(() => {
        dispatch({
            type: 'CHANGE_LANGUAGE',
            language
        });
    });
};
